import React from 'react';
import InfoSectionChina from './InfoSectionChina';
import OnlyForm from './OnlyForm';


import Footer from './Footer';


const Home = () => {
    return (
        <div>
            <InfoSectionChina />
            <OnlyForm />

            <Footer />


        </div>
    );
};

export default Home;